/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const SNACKBAR_ALERT_DEFAULT_PROPS = {
  showSnackbar: true,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as 'success' | 'error'
};
export const USER_NAME = 'userName';
export const PAGE_NUMBER = 1;
export const PAGE_SIZE = 50;
export const TITLE = 'accessing Users';
export const SUBJECT_ID_COPIED_TO_CLIPBOARD = 'Subject ID copied to clipboard';
export const DELETE_TOOLTIP = 'delete';

export const DELETE_USER_BUTTON_OK = 'Delete User';
export const BUTTON_CANCEL = 'Cancel';
export const DELETE_USER_TITLE = 'Delete User?';
export const DELETE_USER_CONTENT = 'Are you sure you want to delete ';
export const USER_ROLES_TITLE = 'This user is associated with the following roles:';
export const USER_DELETE_ERROR_MESSAGE = 'Error in deleting user: ';
export const USER_DELETE_SUCCESS_MESSAGE = 'User {0} has been deleted successfully';
export const USER_DETAILS_ERROR_MESSAGE = 'Error in fetching user details ';

export const STATUS_CODES = {
  "ERROR_404": 404,
  "ERROR_409": 409
};
export const DROPDOWN_MAX_HEIGHT = 350;
export const DISPLAY_NAME = 'displayName';
export const LAST_NAME = 'lastName';
export const FIRST_NAME = 'givenName';
export const EMAIL = 'email';
export const FOR = 'for';
export const SEARCH_FILTER_KEYS = [
  { id: 1, displayName: 'User Name', key: USER_NAME, default: true },
  { id: 2, displayName: 'Display Name', key: DISPLAY_NAME, default: false },
  { id: 3, displayName: 'First Name', key: FIRST_NAME, default: false },
  { id: 4, displayName: 'Last Name', key: LAST_NAME, default: false },
  { id: 5, displayName: 'Email', key: EMAIL, default: false }
];
export const SEARCH_USER = 'Search (Min. 3 chars)';
export const ADD_USER = "Add User";

export const ASSIGNED_ROLES = "Assigned Roles";
export const ASSIGNED_LOCATIONS = "Assigned Sub-Realms";

export const NO_ROLES_MESSAGE_POPOVER = "There are no assigned roles available for this user. For assigning roles goto the details page Roles section";
export const NO_LOCATIONS_MESSAGE_POPOVER = "There are no assigned locations available for this user.";
export const ERROR_MESSAGE = "There is some problem in fetching data";

export const CLOSE = 'Close';
export const BULK_ROLE_ASSIGNMENT_LOWER_BOUND = 2;
export const BULK_ROLE_ASSIGNMENT_UPPER_BOUND = 20;
